import React, { FC, memo, useCallback, useMemo } from 'react';
import { deleteModel } from '../../../api/fetch-functions/model';
import { viewTexts } from '../../../constants/view-texts';
import { useToken } from '../../../global-state/auth-state';
import { fetchModelListOf } from '../../../global-state/database/model-list';
import { IModelType } from '../../../types/record/model';
import { ConfirmDeleteDialogTemplate } from '../confirm-delete-dialog-template/confirm-delete-dialog-template';

const vt = viewTexts.dialogs.deleteModel;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  model: IModelType;
  companyId: number;
}

export const DeleteModelDialog: FC<Props> = memo(
  ({ open, onClose, model: modelInit, companyId }: Readonly<Props>) => {
    const message = useMemo<string[]>(() => vt.message(modelInit.name), [
      modelInit.name
    ]);

    /* event handler */

    const token = useToken();

    const closeOnClick = useCallback(
      (reason: 'yes' | 'no') => {
        if (reason === 'no') {
          onClose('cancel');
        } else {
          if (token !== undefined && modelInit.name !== undefined) {
            deleteModel(token)(modelInit.id).then(res => {
              if (res.type === 'success') {
                onClose('ok');
                fetchModelListOf(companyId);
              }
            });
          }
        }
      },
      [onClose, modelInit, companyId, token]
    );

    return (
      // TODO: 待機状態のUIを作る
      <ConfirmDeleteDialogTemplate
        title={vt.title}
        messages={message}
        open={open}
        onClose={closeOnClick}
      />
    );
  }
);

DeleteModelDialog.displayName = 'DeleteModelDialog';
